import { gql } from '@apollo/client'
import { PRODUCT_FIELDS } from './fragments/product'

export const FETCH_PRODUCTS = gql`
  ${PRODUCT_FIELDS}
  query allProducts($category: BillingProductCategory) {
    allProducts(category: $category) {
      products {
        ...ProductFields
      }
    }
  }
`
